declare namespace $ {

	type $bog_blitz_lobby_players__players_dict_bog_blitz_lobby_1 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['players_dict'] >
		,
		ReturnType< $bog_blitz_lobby_players['players_dict'] >
	>
	type $bog_blitz_lobby_players__my_lord_str_bog_blitz_lobby_2 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['my_lord_str'] >
		,
		ReturnType< $bog_blitz_lobby_players['my_lord_str'] >
	>
	type $mol_paragraph__title_bog_blitz_lobby_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_major__title_bog_blitz_lobby_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_blitz_lobby_5 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['go_admin'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $bog_blitz_lobby_host__counter_string_bog_blitz_lobby_6 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['counter_string'] >
		,
		ReturnType< $bog_blitz_lobby_host['counter_string'] >
	>
	type $bog_blitz_lobby_host__land_id_bog_blitz_lobby_7 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['land_id'] >
		,
		ReturnType< $bog_blitz_lobby_host['land_id'] >
	>
	type $bog_blitz_lobby_host__quiz_title_bog_blitz_lobby_8 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['quiz_title'] >
		,
		ReturnType< $bog_blitz_lobby_host['quiz_title'] >
	>
	type $bog_blitz_lobby_host__session_bog_blitz_lobby_9 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['session'] >
		,
		ReturnType< $bog_blitz_lobby_host['session'] >
	>
	type $bog_blitz_lobby_host__quiz_data_bog_blitz_lobby_10 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['quiz_data'] >
		,
		ReturnType< $bog_blitz_lobby_host['quiz_data'] >
	>
	type $bog_blitz_lobby_host__Players_bog_blitz_lobby_11 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['Host_players'] >
		,
		ReturnType< $bog_blitz_lobby_host['Players'] >
	>
	type $bog_blitz_lobby_join__player_name_bog_blitz_lobby_12 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['my_player_name'] >
		,
		ReturnType< $bog_blitz_lobby_join['player_name'] >
	>
	type $bog_blitz_lobby_join__avatar_files_bog_blitz_lobby_13 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['my_avatar_files'] >
		,
		ReturnType< $bog_blitz_lobby_join['avatar_files'] >
	>
	type $bog_blitz_lobby_join__join_bog_blitz_lobby_14 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['join'] >
		,
		ReturnType< $bog_blitz_lobby_join['join'] >
	>
	type $bog_blitz_lobby_join__is_synced_bog_blitz_lobby_15 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['is_synced'] >
		,
		ReturnType< $bog_blitz_lobby_join['is_synced'] >
	>
	type $bog_blitz_lobby_join__player_id_bog_blitz_lobby_16 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['my_lord_str'] >
		,
		ReturnType< $bog_blitz_lobby_join['player_id'] >
	>
	type $bog_blitz_lobby_join__profile_avatar_uri_bog_blitz_lobby_17 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['profile_avatar_uri'] >
		,
		ReturnType< $bog_blitz_lobby_join['profile_avatar_uri'] >
	>
	type $bog_blitz_lobby_join__profile_name_bog_blitz_lobby_18 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['profile_name'] >
		,
		ReturnType< $bog_blitz_lobby_join['profile_name'] >
	>
	type $bog_blitz_lobby_waiting__counter_string_bog_blitz_lobby_19 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['counter_string'] >
		,
		ReturnType< $bog_blitz_lobby_waiting['counter_string'] >
	>
	type $bog_blitz_lobby_waiting__quiz_title_bog_blitz_lobby_20 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['quiz_title'] >
		,
		ReturnType< $bog_blitz_lobby_waiting['quiz_title'] >
	>
	type $bog_blitz_lobby_waiting__Players_bog_blitz_lobby_21 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['Host_players'] >
		,
		ReturnType< $bog_blitz_lobby_waiting['Players'] >
	>
	type $mol_view__sub_bog_blitz_lobby_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_blitz_lobby_game__land_id_bog_blitz_lobby_23 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['land_id'] >
		,
		ReturnType< $bog_blitz_lobby_game['land_id'] >
	>
	type $bog_blitz_lobby_game__session_bog_blitz_lobby_24 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['session'] >
		,
		ReturnType< $bog_blitz_lobby_game['session'] >
	>
	type $bog_blitz_lobby_game__quiz_data_bog_blitz_lobby_25 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['quiz_data'] >
		,
		ReturnType< $bog_blitz_lobby_game['quiz_data'] >
	>
	type $bog_blitz_lobby_game__game_state_bog_blitz_lobby_26 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['game_state'] >
		,
		ReturnType< $bog_blitz_lobby_game['game_state'] >
	>
	type $bog_blitz_lobby_game__current_question_bog_blitz_lobby_27 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['current_question'] >
		,
		ReturnType< $bog_blitz_lobby_game['current_question'] >
	>
	type $bog_blitz_lobby_game__current_question_text_bog_blitz_lobby_28 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['current_question_text'] >
		,
		ReturnType< $bog_blitz_lobby_game['current_question_text'] >
	>
	type $bog_blitz_lobby_game__my_player_bog_blitz_lobby_29 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['my_player'] >
		,
		ReturnType< $bog_blitz_lobby_game['my_player'] >
	>
	type $bog_blitz_lobby_game__my_answers_bog_blitz_lobby_30 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['my_answers'] >
		,
		ReturnType< $bog_blitz_lobby_game['my_answers'] >
	>
	type $bog_blitz_lobby_game__is_host_bog_blitz_lobby_31 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['is_host'] >
		,
		ReturnType< $bog_blitz_lobby_game['is_host'] >
	>
	type $bog_blitz_lobby_game__paused_at_bog_blitz_lobby_32 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['paused_at'] >
		,
		ReturnType< $bog_blitz_lobby_game['paused_at'] >
	>
	type $bog_blitz_lobby_game__manual_mode_bog_blitz_lobby_33 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['manual_mode'] >
		,
		ReturnType< $bog_blitz_lobby_game['manual_mode'] >
	>
	type $bog_blitz_lobby_game__round_start_bog_blitz_lobby_34 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['round_start'] >
		,
		ReturnType< $bog_blitz_lobby_game['round_start'] >
	>
	type $bog_blitz_lobby_game__duration_bog_blitz_lobby_35 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['duration'] >
		,
		ReturnType< $bog_blitz_lobby_game['duration'] >
	>
	type $bog_blitz_lobby_game__total_questions_bog_blitz_lobby_36 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['total_questions'] >
		,
		ReturnType< $bog_blitz_lobby_game['total_questions'] >
	>
	type $bog_blitz_lobby_game__current_question_index_bog_blitz_lobby_37 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['current_question_index'] >
		,
		ReturnType< $bog_blitz_lobby_game['current_question_index'] >
	>
	type $bog_blitz_lobby_game__players_dict_bog_blitz_lobby_38 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['players_dict'] >
		,
		ReturnType< $bog_blitz_lobby_game['players_dict'] >
	>
	type $bog_blitz_lobby_game__my_lord_str_bog_blitz_lobby_39 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['my_lord_str'] >
		,
		ReturnType< $bog_blitz_lobby_game['my_lord_str'] >
	>
	type $bog_blitz_lobby_reactions__my_answers_bog_blitz_lobby_40 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['my_answers'] >
		,
		ReturnType< $bog_blitz_lobby_reactions['my_answers'] >
	>
	type $bog_blitz_lobby_reactions__players_dict_bog_blitz_lobby_41 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['players_dict'] >
		,
		ReturnType< $bog_blitz_lobby_reactions['players_dict'] >
	>
	type $bog_blitz_lobby_reactions__is_host_bog_blitz_lobby_42 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby['is_host'] >
		,
		ReturnType< $bog_blitz_lobby_reactions['is_host'] >
	>
	export class $bog_blitz_lobby extends $mol_page {
		counter_string( ): string
		session( ): any
		quiz_data( ): any
		players_dict( ): any
		my_lord_str( ): string
		Host_players( ): $bog_blitz_lobby_players
		my_player_name( next?: string ): string
		my_avatar_files( next?: readonly(File)[] ): readonly(File)[]
		join( next?: any ): any
		is_synced( ): boolean
		profile_avatar_uri( ): string
		profile_name( ): string
		No_game_text( ): $mol_paragraph
		go_admin( next?: any ): any
		Go_admin( ): $mol_button_major
		game_state( ): string
		current_question( ): any
		current_question_text( ): string
		my_player( ): any
		my_answers( ): any
		is_host( ): boolean
		paused_at( ): number
		manual_mode( ): boolean
		round_start( ): number
		duration( ): number
		total_questions( ): number
		current_question_index( ): number
		lobby_content( ): readonly(any)[]
		Head( ): any
		players_string( ): string
		land_id( ): string
		quiz_title( ): string
		Host( ): $bog_blitz_lobby_host
		Join_screen( ): $bog_blitz_lobby_join
		Waiting( ): $bog_blitz_lobby_waiting
		No_game( ): $mol_view
		Game_screen( ): $bog_blitz_lobby_game
		Reactions( ): $bog_blitz_lobby_reactions
		body( ): ReturnType< $bog_blitz_lobby['lobby_content'] >
	}
	
}

//# sourceMappingURL=lobby.view.tree.d.ts.map